import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import { light } from './vuetify/theme';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    options: { customProperties: true },
    dark: false, // Setting $vuetify.theme.dark to true will globally switch the theme
    themes: {
      light,
    },
  },
});
